import React, {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
// local
import ButtonDelete from "components/buttons/ButtonDelete";

const SignContractInvoiceProfileData = ({profile, countries, onRemove, addClass}) => {
  const {t} = useTranslation();

  const [hoverClass, setHoverClass] = useState("");
  const removable = useMemo(() => !!onRemove, [onRemove]);

  const itemLanguageKey = "SIGN_CONTRACT_INVOICING_PROFILES_MODAL_ITEM_";

  const hasAddressFields =
    profile.addressMain ||
    profile.addressExtra ||
    profile.addressPostalCode ||
    profile.addressCity;
  const hasFirstColumn = hasAddressFields || profile.intDesignation;
  const hasSecondColumn = profile.email || profile.glnNumber || profile.vatNumber;
  const hasThirdColumn = profile.peppolId || profile.inxNumber;
  const noDataClass =
    !hasFirstColumn && !hasSecondColumn && !hasThirdColumn ? " pt-6" : "";

  const ProfileLabel = ({label, value, addClass}) =>
    value && (
      <div className={addClass}>
        {label && <div className="__uppercase __bold fz-10 mb-1">{t(label)}</div>}
        <div className="fz-13">{value}</div>
      </div>
    );

  return (
    <div
      className={`invoice-profile-data ${hoverClass}${noDataClass}${
        addClass ? ` ${addClass}` : ""
      }`}
    >
      {hasFirstColumn && (
        <div className="mr-8">
          <ProfileLabel
            label={`${itemLanguageKey}ADDRESS_MAIN`}
            value={profile.addressMain}
          />
          <ProfileLabel value={profile.addressExtra} />
          <ProfileLabel
            value={`${profile.addressPostalCode ?? ""} ${profile.addressCity ?? ""}`}
          />
          <ProfileLabel
            value={
              countries.find((country) => country.value === profile.addressCountry)
                ?.label ?? ""
            }
          />
          <ProfileLabel
            label={`${itemLanguageKey}INT_DESIGNATION`}
            value={profile.intDesignation}
            addClass={hasAddressFields ? "mt-4" : ""}
          />
        </div>
      )}
      {hasSecondColumn && (
        <div className="mr-8">
          <ProfileLabel
            label={`${itemLanguageKey}EMAIL`}
            value={profile.email}
            addClass="mb-4"
          />
          <ProfileLabel
            label={`${itemLanguageKey}GLN_NUMBER`}
            value={profile.glnNumber}
            addClass="mb-4"
          />
          <ProfileLabel
            label={`${itemLanguageKey}VAT_NUMBER`}
            value={profile.vatNumber}
          />
        </div>
      )}
      {hasThirdColumn && (
        <div>
          <ProfileLabel
            label={`${itemLanguageKey}PEPPOL_ID`}
            value={profile.peppolId}
            addClass="mb-4"
          />
          <ProfileLabel
            label={`${itemLanguageKey}INX_NUMBER`}
            value={profile.inxNumber}
          />
        </div>
      )}
      {removable && (
        <ButtonDelete
          addClass="pos-a top-2 right-2 pa-0"
          onMouseOver={() => setHoverClass(" __hover")}
          onMouseLeave={() => setHoverClass("")}
          onClick={onRemove}
          activeOnHover
        />
      )}
    </div>
  );
};

export default SignContractInvoiceProfileData;
